/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from './shared/spinner/spinner.component.ngfactory';
import * as i4 from '../../app/shared/spinner/spinner.component';
import * as i5 from '@angular/common';
import * as i6 from '../../app/app.component';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,16777216,(null as any),(null as any),3,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,212992,(null as any),0,i2.RouterOutlet,[i2.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
          1,'app-spinner',([] as any[]),(null as any),(null as any),(null as any),
          i3.View_SpinnerComponent_0,i3.RenderType_SpinnerComponent)),i1.ɵdid(3,180224,
          (null as any),0,i4.SpinnerComponent,[i2.Router,i5.DOCUMENT],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(1,49152,(null as any),0,i6.AppComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i6.AppComponent> = i1.ɵccf('app-root',
    i6.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9saWIvamVua2lucy9qb2JzL25vc3RyYS1tdWZpdC1pbmZvLXByb2Qvd29ya3NwYWNlL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvbGliL2plbmtpbnMvam9icy9ub3N0cmEtbXVmaXQtaW5mby1wcm9kL3dvcmtzcGFjZS9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy92YXIvbGliL2plbmtpbnMvam9icy9ub3N0cmEtbXVmaXQtaW5mby1wcm9kL3dvcmtzcGFjZS9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50Lmh0bWwiLCJuZzovLy92YXIvbGliL2plbmtpbnMvam9icy9ub3N0cmEtbXVmaXQtaW5mby1wcm9kL3dvcmtzcGFjZS9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHJvdXRlci1vdXRsZXQ+PGFwcC1zcGlubmVyPjwvYXBwLXNwaW5uZXI+PC9yb3V0ZXItb3V0bGV0PiIsIjxhcHAtcm9vdD48L2FwcC1yb290PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBOzBEQUFBO1VBQUEsNkJBQWU7VUFBQTttRUFBQSxVQUFBO1VBQUE7VUFBQTtJQUFmOzs7O29CQ0FBO01BQUE7YUFBQTtVQUFBOzs7In0=



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/nostra-mufit-info-prod/workspace/src/$$_gendir/app/app.component.ngfactory.ts